import axios from 'axios';

/**
 * Update a resource using PUT request.
 * 
 * @param {string} url - The endpoint URL for the resource.
 * @param {object} data - The data to update the resource with.
 * @returns {Promise<object>} - The response data from the server.
 */
export const putRequest = async (url, data) => {
  try {
    const response = await axios.put(url, data);
    return response.data; // Return the updated resource
  } catch (error) {
    console.error('Error updating resource:', error);
    throw error; // Propagate the error to be handled by the caller
  }
};